import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { Main } from './pages/Main/Main';
import st from './styles/app.module.css';

function App() {
  return (
    <div className={st.appRoot}>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'rgba(12, 16, 26, 0.95)',
            color: '#e8ecf4',
            border: '1px solid rgba(255,255,255,0.08)',
          },
        }}
      />

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
